import { BuildingType, ClientType, CustomerType, SltStatusDataOut, TypeOfConnection } from "src/app/models/customer.model";
import { KycStatus } from "../_enums/kyc-status";
import { Title } from "../_enums/title.enum";
import { KycAccountInformation } from "./kyc-account-information";
import { KycBuildingOwnerInformation } from "./kyc-building-owner-information";
import { Rejection } from "./kyc-rejection";
import { Gender } from "../_enums/gender.enum";
import { BuildingDevelopmentStage } from "src/app/models/building.model";

export enum OwnershipStatus {
    Owner = 0,
    Tenant = 1
}

export class KycAccountData {
    id: number;
    accountNumber?: string | null;
    applicationNumber?: string | null;
    email: string | null;
    phoneNumber: string | null;
    dialCode: string | null;
    // password: string | null;
    utilityId?: number | null;
    lastUpdateTime?: string | null;
    title: number | null;
    surname: string | null;
    firstName?: string | null;
    dateOfBirth: Date | null;
    identificationIssueDate: Date | null;
    identificationExpiryDate: Date | null;
    nameOfEmployer: string | null;
    employerAddress?: AddressModel
    meterNumberLandlord: string | null;
    accountNumberForPremissesLandlord: string | null;
    identificationOfLandlord: number | null;
    personalIdNumberOfLandlord: string | null;
    addressOfLandlord: AddressModel
    typeOfPremises: number | null;
    useOfPremises: number | null;
    addressPreviousCustomer?: AddressModel
    meterNumberPreviousCustomer: string | null;
    accountNumberPreviousCustomer: string | null;
    buildingOwner?: string | null;
    buildingOwnerAddress?: AddressModel;
    buildingOwnerPhoneNumber?: string | null;
    identificationOfBuildingOwner?: number | null;
    personalIdNumberOfBuildingOwner?: string | null;
    nameOfEmployerOfBuildingOwner?: string | null;
    employerAddressOfBuildingOwner?: AddressModel
    buildingOwnerEmployerPhoneNumber?: string | null;
    buildingOwnerEmail?: string | null;
    loadRequirements: LoadRequirement[];
    propertyNature: number | null;
    typeOfProperty: number | null;
    hasPlanningPermissions: boolean;
    hasMeter: boolean;
    meterNumber: string | null;
    buildingOwnerAccountNumber?: string | null;
    estimatedMaxLoad: number | null;
    requestedVoltage: number | null;
    nameOfElectricalEngineer?: string | null;
    addressElectricalEngineer?: AddressModel
    licenseNumber: string | null;
    category: string | null;
    engineerDate: Date | null;
    meterNumberRequestingForChange: string | null;
    accountNumberRequestingForChange: string | null;
    customersSignitureUrl: string | null;
    landlordsSignitureUrl: string | null;
    electricalContractorsSignitureUrl: string | null;
    applicantsSignitureUrl: string | null;
    passportUrl: string | null;
    customersSignitureName: string | null;
    landlordsSignitureName: string | null;
    electricalContractorsSignitureName: string | null;
    applicantsSignitureName: string | null;
    passportName: string | null;
    balanceAmountAgreement?: number | null;
    debtRepaymentOption?: number | null;
    debtAmountAcceptance: boolean;
    meterRequest?: MeterRequest;
    currentPage: number;
    accountInformation?: KycAccountInformation;
    buildingOwnerInformation?: KycBuildingOwnerInformation;
    activityProgressPill?: ActivityProgressPill[];
    currentStatus?: KycStatus;
    rejections?: Rejection[];
    profilePictureUrl: string | null;
    lastPaymentAmount?: string | null;
    lastPaymentDate?: string | null;
    currentDebtBalance?: string | null;
    bankVerificationNumber?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    instalmentPlan?: InstalmentPlan
    gender?: Gender | null;
    middleName?: string | null;
    nationality?: string | number | null;
    serviceType?: ServiceType | null;
    subServiceType?: KycSubServiceType | null;
    useOfPremise?: BuildingType | null;
    premiseType?: string | null;
    premiseCategory?: string | null;
    activity?: string | null;
    subActivity?: string | null;
    buildingDevelopmentStage?: BuildingDevelopmentStage | null;
    ownershipStatus: OwnershipStatus | null;
    sltStatusId: number | null;
    sltStatus?: SltStatusDataOut;
    nin: string | null;
    proofOfOwnershipUrl: string | null;
    letterOfConsentUrl: string | null;
    tenancyAgreementUrl: string | null;
    letterOfAuthorizationUrl: string | null;
    clientType?: ClientType;
    customerType?: CustomerType;
    customerId: number | null;

    proofOfOwnershipName: string | null;
    letterOfConsentName: string | null;
    letterOfAuthorizationName: string | null;
    tenancyAgreementName: string | null;
    relatedAccounts : RelatedAccount[] | [];
    kycStage?: KycStage | null;
    constructor(data: any) {
        this.id = data.id;
        this.accountNumber = data.accountNumber ?? '';
        this.applicationNumber = data.applicationNumber ?? '';
        this.email = data.email ?? '';
        this.phoneNumber = data.phoneNumber ?? '';
        this.utilityId = data.utilityId ?? '';
        this.lastUpdateTime = data.lastUpdateTime ?? '';
        this.title = data.title ?? Title.Mr;
        this.surname = data.surname ?? '';
        this.firstName = data.firstName ?? '';
        this.dateOfBirth = data.dateOfBirth ?? '';
        this.identificationExpiryDate = data.identificationExpiryDate ?? '';
        this.identificationIssueDate = data.identificationIssueDate ?? '';
        this.nameOfEmployer = data.nameOfEmployer ?? '';
        this.addressOfLandlord = new AddressModel(data.addressOfLandlord);
        this.meterNumberLandlord = data.meterNumberLandlord ?? '';
        this.accountNumberForPremissesLandlord = data.accountNumberForPremissesLandlord ?? '';
        this.identificationOfLandlord = data.identificationOfLandlord;
        this.personalIdNumberOfLandlord = data.personalIdNumberOfLandlord ?? '';
        this.typeOfPremises = data.typeOfPremises ?? '';
        this.useOfPremises = data.useOfPremises ?? '';
        this.meterNumberPreviousCustomer = data.meterNumberPreviousCustomer ?? '';
        this.meterNumber = data.meterNumber ?? '';
        this.accountNumberPreviousCustomer = data.accountNumberPreviousCustomer ?? '';
        this.buildingOwnerPhoneNumber = data.buildingOwnerPhoneNumber ?? '';
        this.identificationOfBuildingOwner = data.identificationOfBuildingOwner;
        this.personalIdNumberOfBuildingOwner = data.personalIdNumberOfBuildingOwner ?? '';
        this.nameOfEmployerOfBuildingOwner = data.nameOfEmployerOfBuildingOwner ?? '';
        this.employerAddressOfBuildingOwner = data.employerAddressOfBuildingOwner ?? '';
        this.buildingOwnerEmployerPhoneNumber = data.buildingOwnerEmployerPhoneNumber ?? '';
        this.buildingOwnerEmail = data.buildingOwnerEmail ?? '';
        this.loadRequirements = data.loadRequirements ? data.loadRequirements.map((el: any) => new LoadRequirement(el)) : [];
        this.propertyNature = data.propertyNature;
        this.typeOfProperty = data.typeOfProperty ?? '';
        this.hasPlanningPermissions = data.hasPlanningPermissions ?? false;
        this.hasMeter = data.hasMeter ?? false;
        this.buildingOwnerAccountNumber = data.buildingOwnerAccountNumber ?? '';
        this.estimatedMaxLoad = data.estimatedMaxLoad;
        this.requestedVoltage = data.requestedVoltage;
        this.nameOfElectricalEngineer = data.nameOfElectricalEngineer ?? '';
        this.buildingOwner = data.buildingOwner ?? '';
        this.licenseNumber = data.licenseNumber ?? '';
        this.category = data.category ?? '';
        this.engineerDate = data.engineerDate ?? '';
        this.meterNumberRequestingForChange = data.meterNumberRequestingForChange ?? '';
        this.accountNumberRequestingForChange = data.accountNumberRequestingForChange ?? '';
        this.customersSignitureUrl = data.customersSignitureUrl ?? '';
        this.landlordsSignitureUrl = data.landlordsSignitureUrl ?? '';
        this.electricalContractorsSignitureUrl = data.electricalContractorsSignitureUrl ?? '';
        this.applicantsSignitureUrl = data.applicantsSignitureUrl ?? '';
        this.passportUrl = data.passportUrl ?? '';
        this.customersSignitureName = data.customersSignitureName ?? '';
        this.landlordsSignitureName = data.landlordsSignitureName ?? '';
        this.electricalContractorsSignitureName = data.electricalContractorsSignitureName ?? '';
        this.applicantsSignitureName = data.applicantsSignitureName ?? '';
        this.passportName = data.passportName ?? '';
        this.balanceAmountAgreement = data.balanceAmountAgreement ?? 0;
        this.debtRepaymentOption = data.debtRepaymentOption ?? null;
        this.debtAmountAcceptance = data.debtAmountAcceptance ?? false;
        this.currentPage = data.currentPage ?? 1;
        this.dialCode = data.dialCode;
        this.accountInformation = new KycAccountInformation(data.accountInformation);
        this.buildingOwnerInformation = new KycBuildingOwnerInformation(data.buildingOwnerInformation);
        this.currentStatus = data.currentStatus ?? KycStatus.Incomplete;
        this.rejections = data.rejections ? data.rejections.map((el: any) => new Rejection(el)) : [];
        this.profilePictureUrl = data.profilePictureUrl ?? '';
        this.lastPaymentAmount = data.lastPaymentAmount ?? '';
        this.lastPaymentDate = data.lastPaymentDate ?? '';
        this.currentDebtBalance = data.currentDebtBalance ?? '';
        this.bankVerificationNumber = data.bankVerificationNumber ?? '';
        this.latitude = data.latitude ?? null;
        this.longitude = data.longitude ?? null;
        this.activityProgressPill = data.activityProgressPill ?? '';
        this.meterRequest = data.meterRequest ?? null;
        this.instalmentPlan = data.instalmentPlan ?? null;
        this.middleName = data.middleName ?? '';
        this.gender = data.gender == 'Male' ? Gender.Male : data.gender == 'Female' ? Gender.Female : null;
        this.nationality = data.nationality ?? null;
        this.serviceType = data.serviceType ?? null;
        this.subServiceType = data.subServiceType ?? null;
        this.buildingDevelopmentStage = data.buildingDevelopmentStage ?? null;
        this.activity = data.activity ?? null;
        this.subActivity = data.subActivity ?? null;
        this.premiseType = data.premiseType ?? null;
        this.premiseCategory = data.premiseCategory ?? null;
        this.useOfPremise = data.useOfPremise ?? null;
        this.ownershipStatus = data.ownershipStatus ?? null;
        this.nin = data.nin ?? '';
        this.sltStatusId = data.sltStatusId ?? null;
        this.sltStatus = data.sltStatus ?? null;
        this.proofOfOwnershipUrl = data.proofOfOwnershipUrl ?? null;
        this.letterOfConsentUrl = data.letterOfConsentUrl ?? null;
        this.tenancyAgreementUrl = data.tenancyAgreementUrl ?? null;
        this.letterOfAuthorizationUrl = data.letterOfAuthorizationUrl ?? null;
        this.proofOfOwnershipName = data.proofOfOwnershipName ?? null;
        this.letterOfConsentName = data.letterOfConsentName ?? null;
        this.letterOfAuthorizationName = data.letterOfAuthorizationName ?? null;
        this.tenancyAgreementName = data.tenancyAgreementName ?? null;
        this.customerType = data.customerType ?? null;
        this.clientType = data.clientType ?? null;
        this.customerId = data.customerId ?? null;
        this.relatedAccounts = data.relatedAccounts ?? null;
        this.kycStage = data.kycStage ?? null;
    }
}

export enum ServiceType {
    KCG = 1,
    NKCG = 2
}

export enum KycSubServiceType {
    PublicLoad = 1,
    MeterReplacement = 2,
    Migration = 3,
    Separation = 4,
    PointLoadTransformer = 5,
    DedicatedFeeder = 6,
    NewService = 7,
    UpgradeToKcg = 8
}

export class AddressModel {
    houseNo: string | null;
    street: string | null;
    landmark: string | null;
    city: string | null;
    area: string | null;
    areaId: number | null;
    subGeographicalRegionId: number | null;
    
    constructor(data: any) {
        this.houseNo = data?.houseNo ?? '';
        this.street = data?.street ?? '';
        this.landmark = data?.landmark ?? '';
        this.city = data?.city ?? '';
        this.area = data?.area ?? '';
        this.areaId = data?.areaId ?? null;
        this.subGeographicalRegionId = data?.subGeographicalRegionId ?? null;
    }
}

export class LoadRequirement {
    id: number | null;
    name?: string | null;
    number: number | null;
    wattage: number | null;
    utilityId?: number | null;

    constructor(data: any) {
        this.id = data?.id ?? 0;
        this.name = data?.name ?? '';
        this.number = data?.number ?? 0;
        this.wattage = data?.wattage ?? 0;
        this.utilityId = data?.utilityId ?? 0;
    }
}

export enum CurrentPage {
    PersonalDataI = 1,
    PersonalDataII = 2,
    PersonalDataIII = 3,
    PersonalDataIV = 4,
    LoadRequirements = 5,
    PersonalDataV = 6,
    PersonalDataVI = 7,
    UploadFile = 8,
    AccountInformation = 9,
    UpdateMeterRequestI = 10,
    UpdateMeterRequestII = 11,
    ReviewApplication = 12
}

export interface ServiceRequestHistoryDataOut {
    serviceOrderId: string | null;
    serviceRequestType: KycSubServiceType;
    meterPhase: TypeOfConnection;
    applicationDate: string | null;
    mapId?: string | null;
    mapVendor?: string | null;
    projectStatus?: string | null;
    projectDesignation?: string | null;
    loadRequirements?: LoadRequirement[] | null;
    surveySubmittedDate?: string | null;
    installationSubmittedDate?: string | null;
    assignedDate?: string | null;
    assignedBy?: string | null;
    submittedBy?: string | null;
    reviewedDate?: string | null;
    reviewedBy?: string | null;
    transactionId?: string | null;
    amount?: number | null;
    paymentStatus?: string | null;
    paymentDate?: string | null;
}

export interface ServiceRequestDataIn {
    accountKycId: number;
    accountNumber: string;
    serviceRequestType: KycSubServiceType;
    meterPhase: TypeOfConnection;
    loadRequirements: LoadRequirement[];
}

export class RelatedAccount {
    id?: number;
    serviceOrderId?: string;
    spn?: string;
    accountNumber?: string;
    phaseRequested?: string;

    constructor(data: any) {
        this.id = data?.id;
        this.serviceOrderId = data?.serviceOrderId ?? '';
        this.spn = data?.spn ?? '';
        this.accountNumber = data?.accountNumber ?? '';
        this.phaseRequested = data?.phaseRequested ?? '';
    }
}

export class MeterRequest {
    meterCount?: number;
    friendlyPowerPhase?: string;
    isCableForSeparationNeeded?: boolean;
    singlePhaseCount?: number;
    threePhaseCount?: number;
    constructor(meterCount: number, singlePhaseCount?: number, threePhaseCount?: number, friendlyPowerPhase?: string, isCableForSeparationNeeded?: boolean) {
        this.meterCount = meterCount;
        this.friendlyPowerPhase = friendlyPowerPhase;
        this.isCableForSeparationNeeded = isCableForSeparationNeeded;
        this.singlePhaseCount = singlePhaseCount;
        this.threePhaseCount = threePhaseCount;
    }
}

export class ActivityProgressPill {
    name: string;
    onboardingStatus: OnboardinActivityStatus;
    constructor(data: any) {
        this.name = data?.name ?? '';
        this.onboardingStatus = data?.onboardingStatus ?? null;
    }
}

export enum OnboardinActivityStatus {
    Completed,
    Pending,
    Incomplete
}

export enum InstalmentPlan {
    ThreeMonths = 0,
    SixMonths = 1,
    NineMonths = 2
}

export enum AssignStatus {
    NotAssigned = 1,
    Assigned = 2
}

export enum KycStage {
    ServiceRequest = 1,
    SiteVerification = 2,
    ServiceRequestAuthorization = 3,
    OnboardedCustomers = 4
}